import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

export default function GraficoVolDiaMes({ dados, isFullscreen }) {
  // console.log('dados em GraficoVolDiaMes: ', dados);

  const labels = dados ? dados.map(d => d.mes + "/" + d.ano) : [];
  const valores = dados ? dados.map(d => d.qtd) : [];

  const data = {
    labels,
    datasets: [
      {
        label: '',
        data: valores,
        backgroundColor: 'rgb(166, 108, 255)', // text-blue-900 equivalente
        borderColor: 'rgb(166, 108, 255)',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: 'Soma de Litros',
        font: { size: 16 },
        padding: { bottom: 20 }
      },
      datalabels: {
        color: '#fff',
        font: { weight: 'bold' },
        anchor: 'center',
        align: 'center',
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { stepSize: 1 }
      }
    }
  };

  return (
    <div className={
      isFullscreen 
        ? "bg-white w-full h-full flex items-center justify-center"
        : "bg-white p-4 shadow-sm rounded-lg h-80 flex flex-col items-center justify-center"
    }>
       {dados && dados.length > 0 ? (
        <Bar data={data} options={options} />
      ) : (
        <p className="text-gray-400">Sem dados para exibir - Soma de Litros</p>
      )}
    </div>
  );
}
